"use client";

import { Box, Flex, Heading, Link, Text } from "@chakra-ui/react";
import RouterLink from "next/link";
import { useRouter } from "next/navigation";
import { ReactNode } from "react";
import { ContentfulImage } from "../../components/ContentfulImage";

import type { ContentGallery } from "../content";

type Props = {
  galleries: ContentGallery[];
};

export function PageComponent(props: Props): ReactNode {
  const router = useRouter();
  return (
    <>
      <Heading mb={4}>Bildergalerie</Heading>
      {props.galleries.length === 0 ? (
        <Text>
          In unserer Bildergalerie sind zur Zeit keine Bilder hochgeladen. Schau
          doch zu einem späteren Zeitpunkt wieder vorbei!
        </Text>
      ) : (
        <Flex
          flexWrap={["nowrap", "nowrap", "wrap"]}
          flexDirection={["column", "column", "row"]}
        >
          {props.galleries.map((gallery) => (
            <Box
              key={gallery.id}
              borderWidth="1px"
              rounded="lg"
              boxShadow="md"
              overflow="hidden"
              mb={[8]}
              mx="auto"
              cursor="pointer"
              transition="box-shadow 0.1s ease"
              _hover={{ boxShadow: "lg" }}
            >
              <ContentfulImage
                src={gallery.preview}
                alt="Bild aus Galerie"
                height={270}
                width={400}
                onClick={() => {
                  router.push(`/bilder/${gallery.id}`);
                }}
              />
              <Box p={4}>
                <Heading as="h3" fontSize="lg" textAlign="center">
                  <Link as={RouterLink} href={`/bilder/${gallery.id}`}>
                    {gallery.title}
                  </Link>
                </Heading>
              </Box>
            </Box>
          ))}
        </Flex>
      )}
    </>
  );
}
